/* ══════════════════════════════════════════════════════════════════════════
   CigarVIU · custom.js   2026-09-04  v2
   assets/custom.js 整檔覆蓋。

   ⚠ 這個檔案有語法錯誤時，整檔都不會執行。改完務必在 console 確認沒有紅字。

   ── v2 拿掉了什麼，為什麼 ──────────────────────────────────────────────
   09-03 版有一段「把抽屜裡的條款勾選框藏起來，並強制解鎖結帳鈕」。
   那一段已經整段刪除。

   實測證明它會把結帳完全鎖死：那個勾選框是 App 注入的，
   它在表單送出時會跑 alert('Please select the terms of service')。
   把框藏起來，客人就永遠勾不到，也就永遠過不了那個 alert ——
   而且畫面上完全看不出原因。

   這是這個站踩過第二次同一種錯：
   **在轉換路徑上，看不見的阻擋比看得見的醜陋貴得多。**
   （第一次是 Turnstile，五週才被發現。）

   現在的做法是排版解：勾選框留著、行為不動，只把它壓成一行。
   規則在 assets/viu.css 的第 2 段。

   ── 這個檔案現在只做兩件事 ────────────────────────────────────────────
   A) /cart 頁的自訂條款閘門。只有在頁面上真的有 [data-viu-cart-terms]
      而且它裡面有勾選框時才會作用；沒有就完全不做事。
      （預設情況下 viu-cart-terms.liquid 不輸出勾選框 ——
        同意由 App 負責，一個購物車不該有兩個勾選框。）
   B) 手機底部導航：購物車那一格開抽屜、數字鏡射 Dawn 的 cart-icon-bubble。
   ══════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ───────── A. /cart 頁的勾選閘門（選用）───────── */

  function syncGate() {
    var wrap = document.querySelector('[data-viu-cart-terms]');
    if (!wrap) return;

    var box = wrap.querySelector('[data-viu-terms-box]');
    if (!box) return; // 沒有自訂勾選框 = 同意交給 App，這裡不插手

    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;

    var ok = box.checked;
    footer.classList.toggle('viu-ct-locked', !ok);

    var hint = wrap.querySelector('[data-viu-terms-hint]');
    if (hint && ok) hint.hidden = true;

    var btnId = wrap.getAttribute('data-gate-button') || 'checkout';
    var btn = document.getElementById(btnId);
    if (btn) btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-viu-terms-box]')) syncGate();
  });

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest ? e.target.closest('[name="checkout"]') : null;
      // 只擋 /cart 頁的結帳鈕。抽屜的同意由 App 負責，不在這裡擋。
      if (!btn || !btn.closest('#main-cart-footer')) return;

      var wrap = document.querySelector('[data-viu-cart-terms]');
      if (!wrap) return;
      var box = wrap.querySelector('[data-viu-terms-box]');
      if (!box || box.checked) return;

      e.preventDefault();
      e.stopPropagation();
      var hint = wrap.querySelector('[data-viu-terms-hint]');
      if (hint) hint.hidden = false;
      box.focus({ preventScroll: true });
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    true
  );

  /* ───────── B. 手機底部導航 ─────────
     購物車數字鏡射 Dawn 的 #cart-icon-bubble。
     Dawn 加購後是用 Section Rendering 重畫那個泡泡，所以只要盯著它變化，
     就不必自己 fetch /cart.js —— 少一個請求，也不會有兩份不同步的數字。 */

  function readBubble() {
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble span:not(.visually-hidden)');
    if (b) return parseInt(b.textContent.trim(), 10) || 0;
    // 泡泡不存在 = 購物車是空的
    return document.querySelector('#cart-icon-bubble .cart-count-bubble') ? null : 0;
  }

  function syncTabCount() {
    var tab = document.querySelector('[data-viu-tab-cart]');
    if (!tab) return;
    var n = readBubble();
    if (n === null) return;
    var el = tab.querySelector('[data-viu-tab-count]');
    if (el) el.textContent = n;
    tab.classList.toggle('has', n > 0);
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('[data-viu-tab-cart]') : null;
    if (!tab) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    e.preventDefault();
    drawer.open();
  });

  /* ───────── 啟動與重繪後的重新套用 ───────── */

  function boot() {
    syncGate();
    syncTabCount();

    var footer = document.getElementById('main-cart-footer');
    if (footer && window.MutationObserver) {
      new MutationObserver(syncGate).observe(footer, { childList: true, subtree: true });
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && window.MutationObserver) {
      new MutationObserver(syncTabCount).observe(bubble, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

